import auth from "./Auth";
import home from "./Home";
import creatememorials from "./CreateMemorials";
import theme02 from "./Theme02";
import theme01 from "./Theme01";
import theme04 from "./Theme04";
import theme03 from "./Theme03";
import biographies from "./Biographies";
import userDashboard from "./UserDashboard";
import editProfile from "./EditProfile";
import searchBiography from "./SearchBiography";
import savedBiography from "./SavedBiography";
import savedByLocation from "./SearchByLocation";
import myBiographies from "./MyBiographies";
import terms from "./Terms";
import privacyPolicy from "./PrivacyPolicy";
import profile from "./Profile";
import notification from "./Notification";
import faq from "./Faq";
import choosePlan from "./ChoosePlan";
import LayoutThree from "./LayoutThree";
import LayoutFour from "./LayoutFour";
import Payment from "./Payment";
import pendingComments from "./PendingComments";
import familyTree from "./FamilyTree";
import screenShot from "./ScreenShot";

const AccessControl = {
  ...auth,
  ...home,
  ...creatememorials,
  ...theme02,
  ...theme01,
  ...theme04,
  ...theme03,
  ...biographies,
  ...userDashboard,
  ...editProfile,
  ...searchBiography,
  ...savedBiography,
  ...savedByLocation,
  ...myBiographies,
  ...terms,
  ...privacyPolicy,
  ...profile,
  ...notification,
  ...faq,
  ...choosePlan,
  ...LayoutThree,
  ...LayoutFour,
  ...Payment,
  ...pendingComments,
  ...familyTree,
  ...screenShot,
};

export default AccessControl;
